import { render, staticRenderFns } from "./groupModal.vue?vue&type=template&id=9d872fa0&scoped=true"
import script from "./groupModal.vue?vue&type=script&lang=js"
export * from "./groupModal.vue?vue&type=script&lang=js"
import style0 from "./groupModal.vue?vue&type=style&index=0&id=9d872fa0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d872fa0",
  null
  
)

export default component.exports